var _path;

var _excluded = ["title", "titleId"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotsMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.544 10.857 C 4.709 11.208,4.501 12.230,5.136 12.864 C 5.645 13.373,6.419 13.359,6.906 12.830 C 7.222 12.488,7.317 12.008,7.155 11.575 C 6.911 10.923,6.170 10.592,5.544 10.857 M11.544 10.857 C 10.709 11.208,10.501 12.230,11.136 12.864 C 11.645 13.373,12.419 13.359,12.906 12.830 C 13.222 12.488,13.317 12.008,13.155 11.575 C 12.911 10.923,12.170 10.592,11.544 10.857 M17.544 10.857 C 16.709 11.208,16.501 12.230,17.136 12.864 C 17.645 13.373,18.419 13.359,18.906 12.830 C 19.222 12.488,19.317 12.008,19.155 11.575 C 18.911 10.923,18.170 10.592,17.544 10.857 ",
    stroke: "none",
    fillRule: "evenodd",
    fill: "black"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsMenu);
export default __webpack_public_path__ + "static/media/dots-menu.c7eb2a07.svg";
export { ForwardRef as ReactComponent };